import React from 'react';
import { IntlProvider } from 'react-intl';

// Import the configuration we created earlier
import { defaultLocale, locales } from "./i18n-config";

interface I18nProps {
    children: React.ReactNode;
}

const I18n: React.FC<I18nProps> = ({ children }) => {
    return (
        <IntlProvider locale={defaultLocale} messages={locales[defaultLocale].messages}>
            {children}
        </IntlProvider>
    );
};

export default I18n;

